<template>
  <div class="p-3">
    <b-overlay :show="loader" rounded="sm">
      <div class="card">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-end" style="gap: 10px">
            {{ $t("employees.searchPnfl") }}
            <b-form-input
                style="width:35%"
                size="xl"
                class="mr-sm-2 mb-sm-0 style-input"
                type="text"
                v-mask="'##############'"
                v-model="$v.inps.$model"
                aria-describedby="input-inpc-live-feedback"
                :state="validateState1()"
            ></b-form-input>
            <b-button style="width: 30%" @click="getPassportDataByApiByPinfl" :disabled="!(inps.length === 14)"
                      variant="primary">
              {{ $t('employees.dataPassport') }}
            </b-button>

          </div>
        </div>
        <div class="card-body">
          <h4 class="card-title mb-4">{{ $t("actions.editData") }}</h4>
          <b-row>
            <b-col lg="6" sm="12" md="12">
              <b-form-group
                  :label="$t('employees.lastName') + $t('lotin') + ' *'"
                  label-for="horizontal-lname-input"
                  label-cols-sm="3"
              >
                <b-form-input
                    id="horizontal-lname-input"
                    v-model="$v.form.lastName.$model"
                    :state="validateState('lastName')"
                    type="text"
                    :disabled="employee.isOneId"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                  :label="$t('employees.firstName') + $t('lotin') + ' *'"
                  label-for="horizontal-firstname-input"
                  label-cols-sm="3"
              >
                <b-form-input
                    id="horizontal-firstname-input"
                    v-model="$v.form.firstName.$model"
                    type="text"
                    :state="validateState('firstName')"
                    :disabled="employee.isOneId"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                  :label="$t('employees.parentName') + $t('lotin') + ' *'"
                  label-for="horizontal-pname-input"
                  label-cols-sm="3"
              >
                <b-form-input
                    id="horizontal-pname-input"
                    v-model="$v.form.parentName.$model"
                    type="text"
                    :state="validateState('parentName')"
                    :disabled="employee.isOneId"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" sm="12" md="12">
              <b-form-group
                  :label="$t('employees.birthDate') + ' *'"
                  label-for="horizontal-bname-input"
                  label-cols-sm="5"
              >
                <b-input-group>
                  <b-form-input
                      class="style-input"
                      size="xl"
                      :state="validateState('birthday')"
                      v-model="$v.form.birthday.$model"
                      v-mask="'##-##-####'"
                      id="example-input"
                      placeholder="DD-MM-YYYY"
                      aria-describedby="input-beginDate-live-feedback"
                      :disabled="employee.isOneId"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                        style="z-index: 1"
                        class="style-input"
                        size="sm"
                        button-only
                        right
                        locale="en-US"
                        aria-controls="example-input"
                        @context="onContext"
                        :disabled="employee.isOneId"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <b-form-group
                  :label="$t('employees.passportGivenDate') + ' *'"
                  label-for="horizontal-bname-input"
                  label-cols-sm="5"
              >
                <b-input-group>
                  <b-form-input
                      class="style-input"
                      size="xl"
                      v-model="$v.form.passportGivenDate.$model"
                      v-mask="'##-##-####'"
                      id="example-input"
                      placeholder="DD-MM-YYYY"
                      aria-describedby="input-beginDat-live-feedback"
                      :state="validateState('passportGivenDate')"
                      :disabled="employee.isOneId"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                        style="z-index: 1"
                        class="style-input"
                        size="sm"
                        button-only
                        right
                        locale="en-US"
                        aria-controls="example-input"
                        @context="onContext2"
                        :disabled="employee.isOneId"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <b-form-group
                  :label="$t('employees.passportEndDate') + ' *'"
                  label-for="horizontal-bname-input"
                  label-cols-sm="5"
              >
                <b-input-group>
                  <b-form-input
                      :state="validateState('passportEndDate')"
                      class="style-input"
                      placeholder="DD-MM-YYYY"
                      size="xl"
                      v-model="$v.form.passportEndDate.$model"
                      v-mask="'##-##-####'"
                      id="example-input"
                      aria-describedby="input-passportEndDate-live-feedback"
                      :disabled="employee.isOneId"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                        style="z-index: 1"
                        class="style-input"
                        size="sm"
                        button-only
                        right
                        locale="en-US"
                        aria-controls="example-input"
                        @context="onContext3"
                        :disabled="employee.isOneId"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <b-row>
            <b-col lg="6" sm="12" md="12">
              <b-form-group
                  :label="$t('references.nationality') + ' *'"
                  label-cols-sm="3"
              >
                <vue-select
                    @search="fetch"
                    class="style-choose"
                    :class="{ error: $v.form.directoryNationalityId.$anyError }"
                    v-model="$v.form.directoryNationalityId.$model"
                    :options="nationalityList"
                    :label="$localeKey()"
                    :reduce="(nationality) => nationality.id"
                />
              </b-form-group>

              <b-form-group
                  :label="$t('references.passportTYpe') + ' *'"
                  label-cols-sm="3"
              >
                <vue-select
                    class="style-choose"
                    :class="{ error: $v.form.passportTypeId.$anyError }"
                    v-model="$v.form.passportTypeId.$model"
                    :options="passportTypeList"
                    :label="$localeKey()"
                    :reduce="(item) => item.id"
                />
              </b-form-group>

              <b-form-group
                  :label="$t('references.marital_status') + ' *'"
                  label-cols-sm="3"
              >
                <vue-select
                    class="style-choose"
                    v-model="$v.form.directoryMaritalStatusId.$model"
                    :options="martialStatusList"
                    :class="{ error: $v.form.directoryMaritalStatusId.$anyError }"
                    :label="$localeKey()"
                    :reduce="(item) => item.id"
                />
              </b-form-group>
            </b-col>
            <b-col lg="6" sm="12" md="12">
              <b-form-group
                  :label="$t('employees.inpc') + ' *'"
                  label-cols-sm="3"
              >
                <b-input-group>
                  <b-form-input
                      v-mask="'##############'"
                      v-model="$v.form.inps.$model"
                      :state="validateState('inps')"
                      class="form-control"
                      :disabled="employee.isOneId"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                        style="z-index: 0"
                        variant="outline-secondary"
                        @click="pnflModal = !pnflModal"
                    >{{ $t("employees.pnfl") }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <b-form-group :label="$t('INN')" label-cols-sm="3">
                <b-form-input
                    v-mask="'#########'"
                    v-model="$v.form.inn.$model"
                    :state="validateState('inn')"
                    class="form-control"
                />
              </b-form-group>

              <b-form-group
                  label-cols-sm="3"
                  :label="$t('references.gender') + ' *'"
                  v-slot="{ ariaDescribedby }"
              >
                <b-form-radio-group
                    size="md"
                    class="radio radio-rounded"
                    id="radio-group-1"
                    v-model="form.directoryGenderId"
                    :options="genders"
                    value-field="id"
                    :text-field="$localeKey()"
                    :aria-describedby="ariaDescribedby"
                    name="radio-options"
                ></b-form-radio-group>
                <div
                    v-if="$v.form.directoryGenderId.$anyError"
                    class="text-danger"
                >
                  {{ $t("warning.enter") }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <b-row>
            <b-col>
              <b-form-group
                  :label="$t('references.propis') + ' *'"
                  label-cols-sm="3"
              >
                <treeselect
                    :disable-branch-nodes="true"
                    class="sstreeselect"
                    :class="{ error: $v.form.directoryRegionAddressId.$anyError }"
                    :options="allRegions"
                    :normalizer="normalizer"
                    v-model="form.directoryRegionAddressId"
                ></treeselect>

                <b-form-textarea
                    :state="validateState('address')"
                    :placeholder="$t('references.propis') + $t('lotin')"
                    rows="3"
                    class="mt-3"
                    v-model="$v.form.address.$model"
                    :no-resize="true"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <b-row>
            <b-col>
              <b-form-group
                  :label="$t('references.exactAdress')"
                  label-cols-sm="3"
              >
                <b-form-checkbox
                    v-if="!status"
                    switch
                    size="lg"
                    id="checkbox-1"
                    v-model="status"
                    name="checkbox-1"
                    class="mt-2"
                >
                  <span style="font-size: 16px" class="mb-2">{{
                      $t("actions.changeInfo")
                    }}</span>
                </b-form-checkbox>
                <div v-if="status">
                  <treeselect
                      :disable-branch-nodes="true"
                      class="sstreeselect"
                      :options="allRegions"
                      :normalizer="normalizer"
                      v-model="$v.form.currentRegionAddressId.$model"
                  ></treeselect>

                  <b-form-textarea
                      v-if="form.currentRegionAddressId !== null"
                      rows="3"
                      :no-resize="true"
                      class="mt-3"
                      v-model="$v.form.currentAddress.$model"
                  ></b-form-textarea>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <b-row>
            <b-col>
              <b-form-group
                  :label="$t('employees.birthAddress') + ' *'"
                  label-cols-sm="3"
              >
                <vue-select
                    class="style-choose"
                    v-model="$v.form.birthCountryId.$model"
                    :class="{ error: $v.form.birthCountryId.$anyError }"
                    :options="countryList"
                    :label="$localeKey()"
                    :reduce="(item) => item.id"
                />
                <vue-select
                    :disabled="!form.birthCountryId"
                    class="style-choose mt-3"
                    v-model="$v.form.birthRegionId.$model"
                    :class="{
                    error: $v.form.birthRegionId.$anyError,
                    ss: !form.birthCountryId,
                  }"
                    :options="regionList"
                    :label="$localeKey()"
                    :reduce="(item) => item.id"
                />
                <vue-select
                    :disabled="!form.birthCountryId || !form.birthRegionId"
                    :class="{
                    error: $v.form.birthDistrictId.$anyError,
                    ss: !form.birthCountryId || !form.birthRegionId,
                  }"
                    class="style-choose mt-3"
                    v-model="$v.form.birthDistrictId.$model"
                    :options="districtList"
                    :label="$localeKey()"
                    :reduce="(item) => item.id"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <div class="row">
            <b-col lg="4" sm="12" md="12">
              <b-form-group :label="$t('employees.email') + '*'">
                <b-form-input
                    v-model="$v.form.email.$model"
                    type="email"
                    :state="validateState('email')"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4" sm="12" md="12">
              <b-form-group :label="$t('employees.phone') + ' *'">
                <b-form-input
                    v-model="$v.form.phone.$model"
                    v-mask="'998#########'"
                    :state="validateState('phone')"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4" sm="12" md="12">
              <b-form-group :label="$t('employees.mobilePhone')">
                <b-form-tags
                    tag-variant="primary"
                    tag-pills
                    :add-button-text="$t('actions.add')"
                    placeholder="998.."
                    input-id="tags-basic"
                    v-model="mobilePhone"
                ></b-form-tags>
              </b-form-group>
            </b-col>
          </div>
        </div>
        <b-card-footer class="bg-white p-4">
          <div class="row">
            <b-col lg="4" sm="12" md="4"></b-col>
            <b-col lg="8" sm="12" md="8">
              <div class="float-right">
                <button
                    style="width: 200px; padding: 13px"
                    @click="$emit('close', false)"
                    class="btn font-weight-bold btn-outline-danger mr-3 m-2"
                >
                  {{ $t("actions.cancel") }}
                </button>
                <button
                    style="width: 200px; padding: 13px"
                    @click="savePasportDate"
                    class="btn font-weight-bold btn-success mr-2"
                >
                  {{ $t("actions.save") }}
                </button>
              </div>
            </b-col>
          </div>
        </b-card-footer>
      </div>

      <b-modal
          :no-close-on-backdrop="true"
          hide-footer
          v-model="pnflModal"
          body-class="p-1"
      >
        <b-row>
          <b-col>
            <div>
              <embed :src="require('@/assets/pnfl.png')" width="100%"/>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import {onlyLotin, hasNotCrilic} from "@/core/util/validators.js";
import EmployeeService from "@/services/employee.service";
import Treeselect from "@riophae/vue-treeselect";
import {validationMixin} from "vuelidate";
import {
  required,
  email,
  integer,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import {mapState, mapActions} from "vuex";

const mustBeAgeBig16 = (value) =>
    value
        ? new Date().getFullYear() -
        new Date(
            value.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
        ).getFullYear() >
        16
        : false;
export default {
  watch: {
    "form.passportGivenDate": {
      async handler(newValue) {
        if (newValue.length === 10) {
          this.form.passportGivenDate = newValue;
          let res = await EmployeeService.getEmployeePassportEndDate(this.form);
          this.form.passportEndDate = res.data;
        } else if (newValue.length < 10) {
          this.form.passportEndDate = null;
        }
      },
    },
    "form.birthCountryId": {
      async handler(newValue) {
        if (newValue) {
          await this.getRegionByParentId({id: newValue, from: "2-step"});
        } else {
          await this.$store.commit("region/setChildList", []);
          await this.$set(this.form, "birthRegionId", null);
        }
      },
    },
    "form.birthRegionId": {
      async handler(newValue) {
        if (newValue) {
          await this.getDistrictByParentId({id: newValue});
        } else {
          await this.$store.commit("region/setDistrictList", []);
          await this.$set(this.form, "birthDistrictId", null);
        }
      },
    },
  },
  computed: {
    ...mapState("employee", ["employee", "passportDate"]),
    ...mapState("passportSeria", {passportSeriaList: "list"}),
    ...mapState("region", {
      allRegions: "listAll",
      countryList: "list",
      regionList: "childList",
      districtList: "districtList",
    }),
    ...mapState("gender", {genders: "list"}),
    ...mapState("nationality", {nationalityList: "list"}),
    ...mapState("maritalStatus", {martialStatusList: "list"}),
    ...mapState("passportSeria", {passportSerialList: "list"}),
    ...mapState("passportType", {passportTypeList: "list"}),
    params() {
      return {
        order: "",
        page: 0,
        limit: 50,
        type: "ASC",
        search: this.search,
      };
    },
  },
  components: {
    Treeselect,
  },
  mixins: [validationMixin],
  validations: {
    form: {
      passportTypeId: {
        required,
      },
      firstName: {
        required,
        onlyLotin,
      },
      lastName: {
        required,
        onlyLotin,
      },
      parentName: {
        required,
        onlyLotin,
      },
      phone: {
        required,
      },
      email: {
        email,
        required,
      },
      directoryRegionAddressId: {
        required,
      },
      currentAddress: {},
      address: {
        required,
        hasNotCrilic,
      },
      currentRegionAddressId: {},
      directoryGenderId: {
        required,
      },
      directoryNationalityId: {
        required,
      },
      directoryMaritalStatusId: {
        required,
      },
      passportGivenDate: {
        required,
      },
      birthday: {
        required,
        mustBeAgeBig16,
      },
      passportEndDate: {
        required,
      },
      inps: {
        required,
        integer,
        maxLength: maxLength(14),
        minLength: minLength(14),
      },
      birthRegionId: {
        required,
      },
      birthCountryId: {
        required,
      },
      birthDistrictId: {
        required,
      },
      inn: {
        integer,
        maxLength: maxLength(9),
        minLength: minLength(9),
      },
    },

    inps: {
      required,
      integer,
      maxLength: maxLength(14),
      minLength: minLength(14),
    },
  },
  data() {
    return {
      status: false,
      loader: false,
      pnflModal: false,
      search: {
        nameUz: "",
        nameRu: "",
        nameLt: "",
      },
      mobilePhone: [],
      form: {
        id: null,
        inn: null,
        passportTypeId: null,
        firstName: "",
        lastName: "",
        parentName: "",
        birthday: null,
        email: "",
        directoryGenderId: null,
        passportSerialId: null,
        passportSerialTitle: "",
        directoryNationalityId: null,
        passportNumber: null,
        phone: "",
        passportGivenDate: null,
        passportEndDate: null,
        inps: "",
        directoryMaritalStatusId: null,
        directoryRegionAddressId: null,
        currentRegionAddressId: null,
        birthRegionId: null,
        birthCountryId: null,
        address: null,
        currentAddress: null,
        status: null,
        loader: false,
        birthDistrictId: null,
      },
      normalizer(node) {
        let nodeEl = {
          id: node.id,
          label:
              this.$i18n.locale == "lt"
                  ? node.nameLt
                  : this.$i18n.locale == "ru"
                      ? node.nameRu
                      : this.$i18n.locale == "uz"
                          ? node.nameUz
                          : "",
        };
        if (node.children && node.children.length > 0) {
          nodeEl.children = node.children;
        } else {
          delete nodeEl.children;
          delete node.children;
        }
        return nodeEl;
      },
      inps: ''
    };
  },
  methods: {
    ...mapActions("employee", ["getEmployee", "getEmployeePasportDate"]),
    ...mapActions("passportSeria", {getpassportSeriaList: "getList"}),
    ...mapActions("nationality", {getNationalList: "getList"}),
    ...mapActions("passportType", {getPasportTypeList: "getList"}),
    ...mapActions("gender", {getGenderList: "getList"}),
    ...mapActions("maritalStatus", {getMaritalStatusList: "getList"}),

    ...mapActions("region", {
      getAllRegions: "listAll",
      getcountryList: "getList",
    }),
    ...mapActions("region", {
      getRegionByParentId: "getByParentId",
      getDistrictByParentId: "getDistrictByParentId",
    }),
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    checkValidity() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return true;
      } else {
        return false;
      }
    },
    async fetch(search, loading) {
      this.search[this.$localeKey()] = search;
      await this.getNationalList(this.params);
    },

    validateState1() {
      const {$dirty, $error} = this.$v.inps;
      return $dirty ? !$error : null;
    },

    setDataFromUrl(res) {
      if (res) {
        this.form.firstName = res.name;
        this.form.lastName = res.surname;
        this.form.inps = res.pin;
        this.form.parentName = res.patronym;
        this.form.birthday = this.$DDMMYYYY(
            this.$replaceData(res.date_of_birth)
        );

        this.form.passportNumber = res.document.number;
        // this.form.passportSerialId = res.document.passportSerialId;
        this.form.passportSerialTitle = res.document.series;
        this.form.passportGivenDate = this.$DDMMYYYY(
            this.$replaceData(res.document.validity_period_begin)
        );

        this.form.passportEndDate = this.$DDMMYYYY(
            this.$replaceData(res.document.validity_period_end)
        );

      } else {
        this.form.inn = null,
        this.form.firstName = null;
        this.form.lastName = null;
        this.form.parentName = null;
        this.form.birthday = null;
        this.form.passportGivenWho = null;
        this.form.passportEndDate = null;
      }
    },

    async getPassportDataByApiByPinfl() {
      this.$v.inps.$touch();

      if (!this.$v.inps.$anyError) {
        this.show = true;
        try {
          let res = await EmployeeService.getPassportDataPnfl(this.inps);
          if (res.data) {
            this.setDataFromUrl(res.data.result)
          }
          this.show = false;
        } catch (error) {
          if (error.request.status === 404) {
            // await this.$toast.error( this.$t( "warning.noInformation" ) );
          } else {
            this.$toast.error(error.message);
          }
          this.show = false;
        }
      } else {
        this.$toast.error(this.$t("warning.dataIncomplate"));
      }
    },

    onContext(ctx) {
      if (ctx.selectedDate) {
        this.form.birthday = this.$DDMMYYYY(
            this.$replaceData(ctx.selectedFormatted)
        );
      }
    },
    onContext2(ctx) {
      if (ctx.selectedDate) {
        this.form.passportGivenDate = this.$DDMMYYYY(
            this.$replaceData(ctx.selectedFormatted)
        );
      }
    },
    onContext3(ctx) {
      if (ctx.selectedDate) {
        this.form.passportEndDate = this.$DDMMYYYY(
            this.$replaceData(ctx.selectedFormatted)
        );
      }
    },
    async savePasportDate(bvModalEvt) {
      this.form.mobilePhone = this.mobilePhone.join();
      this.form.id = parseInt(this.employee.id);

      bvModalEvt.preventDefault();
      if (await this.checkValidity()) {
        return;
      }

      EmployeeService.createEmployeePassportDate(this.form).then((res) => {
        this.$emit("close", false);
      });
    },
  },
  async created() {
    this.loader = true;
    this.form = {...this.form, ...this.passportDate};
    this.getMaritalStatusList(this.params);
    this.getAllRegions();
    this.getcountryList();
    this.getNationalList(this.params);
    this.getPasportTypeList(this.params);
    this.getGenderList(this.params);
    setTimeout(() => {
      this.loader = false;
    }, 300);
  },
};
</script>

<style>
.style-choose .vs__search::placeholder,
.style-choose .vs__dropdown-toggle,
.style-choose .vs__dropdown-menu {
  border: 1px solid #e5eaee;
  padding: 5px;
  color: #394066;
  background: white;
}

.style-choose .vs__selected,
.style-choose .vs1__combobox {
  margin: 0px;
}

.ss .vs__dropdown-toggle {
  background: #f8f8f8;
}

.b-table-sticky-header > .table.b-table > thead > tr > th {
  z-index: 1 !important;
}

tr:hover {
  background-color: transparent !important;
}

td {
  height: 30px !important;
  font-size: 13px !important;
}
</style>

<style lang="scss">
.sstreeselect {
  .vue-treeselect__control {
    height: 43px !important;
    border: 1px solid #e5eaee;
  }

  .vue-treeselect__single-value {
    line-height: 42px !important;
  }

  .vue-treeselect__placeholder {
    line-height: 42px !important;
  }
}

.style-choose.error .vs__dropdown-toggle {
  border-color: red !important;

  .vs__open-indicator {
    fill: red !important;
  }
}

.sstreeselect.error .vue-treeselect__control {
  border-color: red !important;

  svg {
    fill: red;
  }
}
</style>
